import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const includes = ['Fichas teóricas ilustradas listas para fotocopiar', 'Actividades graduadas (3 niveles de dificultad)', 'Trabajos prácticos con materiales de bajo costo (menos de $2.000 ARS)', 'Guías de ejercicios con solucionario docente', 'Evaluaciones diagnóstica, formativa e integradora', 'Conexión con tecnología y realidad argentina 2026', 'Marca de agua Guía Digital 360 y soporte en cada página'];
export function IncludesSection() {
  return <section className="py-10 md:py-20 px-4 bg-brand-light" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-8 md:mb-12" data-id="element-190">
          Cada tomo incluye:
        </h2>

        <div className="bg-white p-6 md:p-12 rounded-3xl shadow-xl mb-8 md:mb-12" data-id="element-191">
          <ul className="space-y-6" data-id="element-192">
            {includes.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-193">
                <div className="bg-brand-green/10 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-194">
                  <CheckIcon className="w-6 h-6 text-brand-green" strokeWidth={3} data-id="element-195" />
                </div>
                <span className="text-xl font-medium text-gray-800" data-id="element-196">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-197">
          <CTAButton text="→ QUIERO TODO ESTO AHORA" href="#compra" data-id="element-198" />
        </div>
      </div>
    </section>;
}